export const REDUCER_KEY_PROJECT_ROUTES = 'projectRoutes';

export const FETCH_PROJECT_ROUTES = 'rs/FETCH_PROJECT_ROUTES';
export const FETCH_PROJECT_ROUTES_SUCCESS = 'rs/FETCH_PROJECT_ROUTES_SUCCESS';
export const FETCH_PROJECT_ROUTES_FAILURE = 'rs/FETCH_PROJECT_ROUTES_FAILURE';

export const PROJECT_ROUTES_SELECTION_CHANGED = 'rs/PROJECT_ROUTES_SELECTION_CHANGED';

export const FETCH_PROJECT_STRUCTURE = 'rs/FETCH_PROJECT_STRUCTURE';
export const FETCH_PROJECT_STRUCTURE_SUCCESS = 'rs/FETCH_PROJECT_STRUCTURE_SUCCESS';
export const FETCH_PROJECT_STRUCTURE_FAILURE = 'rs/FETCH_PROJECT_STRUCTURE_FAILURE';

export const ROUTE_TREE_THUMBNAIL_DETAILS_CHANGED = 'rs/ROUTE_TREE_THUMBNAIL_DETAILS_CHANGED';

export const PROJECT_ROUTES_CLEAR_STATE = 'rs/PROJECT_ROUTES_CLEAR_STATE';
export const SET_VIEW_ROUTES_POSITION = 'rs/SET_VIEW_ROUTES_POSITION';

export const PROJECT_ROUTES_BULK_DELETE = 'rs/PROJECT_ROUTES_BULK_DELETE';
export const PROJECT_ROUTES_BULK_DELETE_SUCCESS = 'rs/PROJECT_ROUTES_BULK_DELETE_SUCCESS';
export const PROJECT_ROUTES_BULK_DELETE_FAILURE = 'rs/PROJECT_ROUTES_BULK_DELETE_FAILURE';

export const projectRoutesCacheKey = (projectId, params) => ['rs', 'projectRoutes', String(projectId), ...(params ? [params] : [])];
